import axios from '@/shared/axios';

export function queryRepayToken(params: any) {
  return axios.post('/payback/h5/token', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryRepayList(params: any) {
  return axios.post('/mx/repay/list/fetch', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

// export function queryRepayDetail(params: any) {
//   return axios.post('/payBack/detail', params, {
//     __interceptorOptions__: {
//       security: true,
//     },
//   });
// }

export function queryRepayCode(params: any) {
  return axios.post('/payBack/activate', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryContractDetail(params: any) {
  return axios.post('/payBack/outstanding/withPlan/list', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryCouponList(params: any) {
  return axios.post('/user/coupons', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function bindCouponOnRepay(params: any) {
  return axios.post('/payback/coupon/bind ', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}
